import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchProductsSummary,} from "../../../../../reduxLib/productLib";
import ProductTop from "./elements/productTop";
import {fetchOrders, fetchOrderSummary} from "../../../../../reduxLib/ordersLib";
import RecentOrder from "./elements/recentOrder";

function DashContainer() {

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const [productSummaryPage,setProductsSummaryPage]=useState([]);
    const productSummaryL= useSelector((state)=> state.productreducer.productSymmaryListpage);
    const state=useSelector((state)=> state.productreducer.state);
    const [filteredProd,setFilteredProd]=useState([]);
    const [orderList,setOrderList]=useState([]);
    const stateO=useSelector((state)=> state.orderreducer.state);
    const orderListL= useSelector((state)=> state.orderreducer.orderList);



    useEffect(() => {
        if (!productSummaryL || productSummaryL.length === 0 ) {

            dispatch(fetchProductsSummary()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setProductsSummaryPage(action.payload);
                    setFilteredProd(
                        action.payload.filter(p => p.isPopular)
                    );

                    console.log("playload ",action.payload);
                    console.log("playload E", productSummaryPage);
                    console.log("filter :",filteredProd);
                }
            });

        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setProductsSummaryPage(productSummaryL);
            setFilteredProd(productSummaryPage.filter(
                p => p.isPopular
            ));
            console.log("filter :",filteredProd);
        }
    }, [dispatch, state,productSummaryL]);

    useEffect(() => {
        if (!orderListL || orderListL.length === 0) {
            dispatch(fetchOrderSummary()).then((action) => {
                if (action.payload) {
                    setOrderList(action.payload);

                    console.log("payload:", action.payload);
                    console.log("orderList (old state):", orderList);
                }
            });
        } else {
            // cached
            setOrderList(orderListL);

            console.log("cached orderListL:", orderListL);
        }
    }, [dispatch, stateO, orderListL]);





    return (

        <div className="dash-container">


            <div id="dashboard-content" className="p-8">
                <div
                    id="stats-overview"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
                >
                    <div className="stat-card p-6 rounded-lg text-white card-hover">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-gray-800 text-sm">Total Revenue</p>
                                <p className="text-2xl text-custom-green font-bold">€{Array.isArray(orderList)
                                    ? orderList?.reduce((sum, o) => sum + (o.totalPrice || 0), 0)
                                    : 0}</p>
                                {/*<p className="text-green-200 text-sm mt-1">+12% from last month</p>*/}
                            </div>
                            <i className="fa-solid fa-euro-sign text-3xl text-gray-600"></i>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow card-hover">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-gray-600 text-sm">Total Orders</p>
                                <p className="text-2xl font-bold text-gray-800">{Array.isArray(orderList) ? orderList.length : 0}</p>
                                {/*<p className="text-green-600 text-sm mt-1">+8% from last month</p>*/}
                            </div>
                            <i className="fa-solid fa-shopping-cart text-3xl text-custom-green"></i>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow card-hover">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-gray-600 text-sm">Active Products</p>
                                <p className="text-2xl font-bold text-gray-800">{productSummaryPage.length}</p>
                                {/*<p className="text-blue-600 text-sm mt-1">5 new this week</p>*/}
                            </div>
                            <i className="fa-solid fa-shopping-bag text-3xl text-custom-green"></i>
                        </div>
                    </div>

                </div>

                <div id="dashboard-grid" className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                    <div id="recent-orders" className="bg-white rounded-lg shadow p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-serif font-bold text-custom-green">
                                Recent Orders
                            </h2>
                            <button  onClick={() => navigate("/admin/ordersAd")} className="text-custom-green hover:text-opacity-80 text-sm font-medium">
                                View All
                            </button>
                        </div>

                        <div className="space-y-4">


                            {
                                Array.isArray(orderList)
                                    ? orderList?.slice(0, 3).map((order,index) => (
                                    <RecentOrder
                                        key={order.orderID}
                                        {...{
                                            orderID: order.orderID,
                                            orderOwnerName: order.orderOwnerName,
                                            totalPrice: order.totalPrice,
                                            status: order.orderStatus,
                                        }}
                                    />
                                )): null

                            }
                        </div>
                    </div>

                    <div id="top-products" className="bg-white rounded-lg shadow p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-serif font-bold text-custom-green">
                                Top Products
                            </h2>
                            <button onClick={() => navigate("/admin/productsAd")} className="text-custom-green hover:text-opacity-80 text-sm font-medium">
                                View All
                            </button>
                        </div>

                        <div className="space-y-4">
                            {
                                filteredProd?.map((product,index) => (
                                    <ProductTop
                                        key={product.productID}
                                        {...{
                                            productID: product.productID,
                                            name: product.name,
                                            description: product.description,
                                            price: product.price,
                                            rating: product.rating,
                                            categoryRelId: product.categoryRelId,
                                            image: product.imageURL,
                                        }}
                                    />

                                ))
                            }
                        </div>
                    </div>
                </div>

                {/*<div id="notifications-alerts" className="bg-white rounded-lg shadow p-6">
                    <h2 className="text-xl font-serif font-bold text-custom-green mb-6">
                        Notifications & Alerts
                    </h2>
                    <div className="space-y-4">
                        <div className="flex items-center p-4 bg-red-50 border-l-4 border-red-400 rounded">
                            <i className="fa-solid fa-exclamation-triangle text-red-400 mr-3"></i>
                            <div>
                                <p className="font-medium text-red-800">Low Stock Alert</p>
                                <p className="text-sm text-red-600">
                                    5 products are running low on stock
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                            <i className="fa-solid fa-clock text-yellow-400 mr-3"></i>
                            <div>
                                <p className="font-medium text-yellow-800">Pending Custom Orders</p>
                                <p className="text-sm text-yellow-600">
                                    3 custom orders are waiting for your review
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center p-4 bg-blue-50 border-l-4 border-blue-400 rounded">
                            <i className="fa-solid fa-info-circle text-blue-400 mr-3"></i>
                            <div>
                                <p className="font-medium text-blue-800">System Update</p>
                                <p className="text-sm text-blue-600">
                                    New features available in your admin panel
                                </p>
                            </div>
                        </div>
                    </div>
                </div>*/}
            </div>
        </div>
    );

}
export default DashContainer;